import React from 'react';

import {connect} from 'react-redux';
import _ from 'lodash';
import {browserHistory} from 'react-router';
import {bindActionCreators} from 'redux';
import * as actions from './redux/searchActions';
import {
  Input, Button, ButtonGroup, Col, Modal, ModalHeader, Container, Label, Row
} from '../Common/reactstrap/lib';
import {Table, Tbody, Thead, Th, Tr, Td} from 'reactable';
import './SearchResults.scss';
import Results from './elements/Results';
import Fuzzy from './elements/Fuzzy';
import Progress from '../Common/Progress';

class Search extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      type: 'results',
      load: 10
    };
    console.log('constructor');
    if (!props.searchData.searchQuery) {
      /*if user open by url*/
      const article = props.location.query.article,
        detailId = props.location.query.detailid || false;
      props.actions.onSearchInputChange(article);
      props.actions.search(article, detailId);
    }

  }

  componentWillMount() {
    this.setState({
      load: this.state.load + 30
    });

  }

  componentWillUnmount() {
    this.props.actions.onSearchInputChange('');

  }

  componentWillReceiveProps(props) {
    let loads = this.state.load + 50;
    let load = loads > 100 ? 100 : loads;
    this.setState({
      load
    });
  }

  setType = (type) =>
    this.setState({
      type
    });

  render() {
     console.log(this.props.searchData.results);
    // console.log('search');
    let results = this.props.searchData.results,
      original = _.filter(results.detailOffers, o => !o.detail.isAnalog),
      analog = _.filter(results.detailOffers, o => o.detail.isAnalog),
      query = this.props.location.query.article,
      names = ['Поставщик', 'Наличие шт.', 'Срок дн.'],
      originalNames = _.concat(['Искомый артикул'], names),
      analogNames = _.concat(['Аналоги'], names),
      checkOffers = results.detailOffers && results.detailOffers.length > 0;
    if (results.detailOffers || results.supposedDetails) return (
      <Container>

        <ButtonGroup className="hidden-sm-up btn-center mt-3">
          <Button color={(this.state.type == 'results') ? 'secondary' : 'info'}
                  onClick={() => this.setType('results')}> Искомый артикул</Button>{' '}
          <Button color={(this.state.type == 'analogs') ? 'secondary' : 'info' }
                  onClick={() => this.setType('analogs')}>Аналоги</Button>
        </ButtonGroup>


        {!results.supposedDetails && checkOffers && <div>
          <Results data={original} name={originalNames} article={query}
                   className={this.state.type != 'results' && ' hidden-sm-down '}/>
          <Results data={analog} name={analogNames}
                   className={this.state.type == 'results' && ' hidden-sm-down no-head '}/>
        </div>}
        {results.supposedDetails && <Fuzzy data={results.supposedDetails} article={query}/>}
        {!checkOffers && !results.supposedDetails && <h2>По вашему запросу {query} ничего не найдено</h2>}
      </Container>
    );
    else return (
      <Progress style={ {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
      }} completed={this.state.load}/>
    );
  }
  ;


}


export default connect(
  (state) => ( {
      searchData: state.search2Reducer,
    }
  ),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch)
  })
)(Search);



/** WEBPACK FOOTER **
 ** ./src/components/Search/index.jsx
 **/